import { render, staticRenderFns } from "./MainTests.vue?vue&type=template&id=8cb24c16"
import script from "./MainTests.vue?vue&type=script&lang=js"
export * from "./MainTests.vue?vue&type=script&lang=js"
import style0 from "./MainTests.vue?vue&type=style&index=0&id=8cb24c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports